import { BrowserView, isBrowser } from "react-device-detect";
import SidebarDesktopView from "./SidebarDesktopView";
import "./Sidebar.css";

/*
collapse
left side
loop through column of options

options props:
number 
a/b
title
options = [[optionName, optionIcon], [optionName1, optionIcon1], [optionName2, optionIcon2]]

// const slr = ["2.0 ft SLR", "3.3 ft SLR"];
// const stormSurge = ["King Tide", "20-yr", "100-yr"];
// const groundwaterCondition = ["Variable GW", "Saturated System"];
// const rainfallAmount = ["10-yr", "25-yr", "100-yr", "10-yr + 20%"];
*/

const Sidebar = ({
 open,
 setOpen,
 drawerWidth,
 checked,
 setChecked,
 sidebarPullerClassname,
 btnClickOne,
 btnClickTwo,
 reductionStateOne,
 reductionStateTwo,
 withAdaptations,
}) => {
 return (
  <>
   {isBrowser && (
    <>
     <BrowserView>
      <SidebarDesktopView
       open={open}
       setOpen={setOpen}
       drawerWidth={drawerWidth}
       checked={checked}
       setChecked={setChecked}
       sidebarPullerClassname={sidebarPullerClassname}
       btnClickOne={btnClickOne}
       btnClickTwo={btnClickTwo}
       reductionStateOne={reductionStateOne}
       reductionStateTwo={reductionStateTwo}
       withAdaptations={withAdaptations}
      />
     </BrowserView>
    </>
   )}
  </>
 );
};

export default Sidebar;
